import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import { useLazyColorMode } from '../ColorModeProvider/ColorModeProvider';

import * as styles from './ThemedExample.css';

interface ThemedExampleProps {
  children: ReactNode;
}

// Copy of https://github.com/seek-oss/braid-design-system/blob/master/site/src/App/ThemeSetting/ThemedExample.tsx
export function ThemedExample({ children }: ThemedExampleProps) {
  const lazyColorMode = useLazyColorMode();

  const ready = Boolean(lazyColorMode);

  return (
    <Box opacity={!ready ? 0 : undefined} transition="fast">
      <Box
        background={
          lazyColorMode?.colorMode === 'darkMode' ? 'customDark' : 'customLight'
        }
        borderRadius="large"
      >
        <Box
          boxShadow="borderNeutralLight"
          borderRadius="large"
          padding="gutter"
          className={[styles.canvas, styles.adaptiveCanvas]}
          paddingY="medium"
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
